import { render, staticRenderFns } from "./ownerDetailHis.vue?vue&type=template&id=43beb48d&scoped=true"
import script from "./ownerDetailHis.vue?vue&type=script&lang=js"
export * from "./ownerDetailHis.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailHis.vue?vue&type=style&index=0&id=43beb48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43beb48d",
  null
  
)

export default component.exports